export default {
  truncate
}

export function truncate (str, startCharactersCound, endCharactersCount) {
  return typeof (str) !== 'string' ? str : `${str.substr(0, startCharactersCound)}..${str.substr(-endCharactersCount)}`
}
